import { DynamicContentType, ImageData } from '@bm-js/atlascloud-shared'
import { ResponsiveImage, Spotlight } from './ResponsiveImage'
import { useImageOptions, useMargin } from '../utils/hooks'

type Props = {
  content: DynamicContentType<ImageData>
  spotlight?: Spotlight
}

export const ImageContent = ({ content, spotlight }: Props) => {
  const imageOptions = useImageOptions(content)
  const margin = useMargin(content)

  return (
    <button
      onClick={() => spotlight?.(content.data.file)}
      className='cursor-pointer w-full'
    >
      <ResponsiveImage
        file={content.data.file}
        className={`w-full max-w-full ${imageOptions} ${margin}`}
      />
      {content.data.imageText ? (
        <figcaption className='mt-2'>{content.data.imageText}</figcaption>
      ) : null}
    </button>
  )
}
